import React from 'react';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';
import { Heading } from 'wix-style-react';
import styles from './SectionTitle.scss';

export default function ({ labels = [], big = true }) {
  const textType = big ? 'H3' : 'H4';

  return (
    <div className={styles.wrapper} data-hook="section-title-wrapper">
      {labels.length > 1 ? (
        <React.Fragment>
          <Heading appearance={textType}>{labels[0]}</Heading>
          <ChevronRight size={22} className={styles.chevron} />
        </React.Fragment>
      ) : null}
      <Heading appearance={textType} data-hook="section-title-navigation-bar-section">
        {labels[labels.length - 1]}
      </Heading>
    </div>
  );
}
